import { PDFDocument } from 'pdf-lib';


/**
 * Wraps a PNG blob in a PDF document
 * The PDF page will be sized to match the PNG dimensions
 * 
 * @param pngBlob - The PNG image blob to embed
 * @returns PDF blob
 */
export async function wrapPngInPdf(pngBlob: Blob): Promise<Blob> {
  // Create a new PDF document
  const pdfDoc = await PDFDocument.create();
  
  // Convert blob to array buffer
  const pngArrayBuffer = await pngBlob.arrayBuffer();
  const pngImage = await pdfDoc.embedPng(pngArrayBuffer);
  
  // Get PNG dimensions
  const { width, height } = pngImage.scale(1);
  
  // Add a page with the same dimensions as the PNG
  const page = pdfDoc.addPage([width, height]);
  
  // Draw the PNG image to fill the entire page
  page.drawImage(pngImage, {
    x: 0,
    y: 0,
    width,
    height,
  });
  
  // Serialize the PDF to bytes
  const pdfBytes = await pdfDoc.save();
  
  // Return as blob
  return new Blob([pdfBytes], { type: 'application/pdf' });
}
